module.exports = __webpack_public_path__ + "media/images/expert__lisa-vittozzi-6d0254cb106fcf287a8c4bd86b0e63bf.png";